export default __webpack_public_path__ + "static/media/takto.e700ae70.svg";